import { t } from 'i18next';
import styles from './LoginDisclaimer.module.scss';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Trans } from 'react-i18next';
import { ExternalLink } from '@/components/common/ExternalLink/ExternalLink';
import { EXTERNAL_LINKS } from '@/constants/external/external-links';
import { disclaimerShown, disclaimerHidden } from '@/store/reducers';

export const LoginDisclaimer: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(disclaimerShown());
    return () => {
      dispatch(disclaimerHidden());
    };
  }, [dispatch]);

  return (
    <div className={styles.loginDisclaimer}>
      <Trans i18nKey="disclaimerText.start" />{' '}
      <ExternalLink
        href={EXTERNAL_LINKS.PRIVACY_POLICY}
        text={t('privacyPolicy')}
      />{' '}
      <Trans i18nKey="and" />{' '}
      <ExternalLink
        href={EXTERNAL_LINKS.TERMS_OF_SERVICE}
        text={t('termsOfService')}
      />
      <Trans i18nKey="disclaimerText.end" />
    </div>
  );
};
